const RE =
  /^(GIR ?0AA|[A-PR-UWYZ]([0-9]{1,2}|[A-HK-Y][0-9]([0-9ABEHMNPRV-Y])?|[0-9][A-HJKPS-UW]) ?[0-9][ABD-HJLNP-UW-Z]{2})$/;

export const isValidPostcode = (raw) => RE.test((raw || "").toUpperCase().replace(/\s+/g, ""));

export const formatPostcode = (raw) => {
  const pc = (raw || "").toUpperCase().replace(/\s+/g, "");
  return pc.length > 3 ? `${pc.slice(0, -3)} ${pc.slice(-3)}` : pc;
};
